import { SagaIterator } from 'redux-saga';
import { call, cancel, takeEvery } from 'redux-saga/effects';
import {
  GlobalAction,
  GlobalActions,
  GlobalPut,
  UpdateLoadedVorvertraege,
} from '@ps20-frontend/shop-integration-redux';
import { App, Vorbelegungdaten, Vorvertrag } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '@ps20-frontend/apps/toolbar-store';
import { select } from '@redux-saga/core/effects';
import { Tarifbereich } from '@ps20/bff-models';
import { ToolbarActions } from '../toolbar.actions';
import { convertTarifbereichToRole } from '../interfaces/versicherungsnehmer';

export function* versicherungsnehmerSaga(): SagaIterator {
  yield takeEvery(
    GlobalActions.UPDATE_VORVERTRAEGE,
    safeSaga(tarifbereichVorbelegen, App.SHOP_TOOLBAR),
  );
}

export function* tarifbereichVorbelegen(action: GlobalAction<UpdateLoadedVorvertraege>): SagaIterator {
  const state: IAppState = yield select();
  const vorvertraege: Vorvertrag[] = action.payload.standardVorvertraege;

  if (!vorvertraege || state.transientState.avLoaded) {
    return yield cancel();
  }

  const vorbelegungdaten: Vorbelegungdaten[] = vorvertraege
    .reduce((acc: Vorbelegungdaten[], vorvertrag: Vorvertrag) => acc.concat(vorvertrag.vorbelegungdaten), [])
    .filter((item: Vorbelegungdaten) => item != null);
  const vorbelegungdatenMitBeibehaltung = vorvertraege
    .filter((vorvertrag: Vorvertrag) => vorvertrag.beibehaltung)
    .reduce((acc: Vorbelegungdaten[], vorvertrag: Vorvertrag) => acc.concat(vorvertrag.vorbelegungdaten), [])
    .filter((item: Vorbelegungdaten) => item != null);

  const tarifbereiche: Tarifbereich[] = vorbelegungdaten
    .reduce((acc: Tarifbereich[], vd: Vorbelegungdaten) => acc.concat(vd.tarifbereich), [])
    .filter((item: Tarifbereich) => item != null);
  const tarifbereicheMitBeibehaltung = vorbelegungdatenMitBeibehaltung
    .reduce((acc: Tarifbereich[], vd: Vorbelegungdaten) => acc.concat(vd.tarifbereich), [])
    .filter((item: Tarifbereich) => item != null);

  if (!tarifbereiche || tarifbereiche.length < 1) {
    return yield cancel();
  }

  const alleTarifbereicheGleich: boolean = tarifbereiche.every(
    (value: Tarifbereich, i: number, array: Tarifbereich[]) => value === array[0],
  );
  const alleTarifbereicheMitBeibehaltungGleich: boolean = (tarifbereicheMitBeibehaltung as Tarifbereich[]).every(
    (value: Tarifbereich, i: number, array: Tarifbereich[]) => value === array[0],
  );
  const assekuranztarifMixed = !alleTarifbereicheMitBeibehaltungGleich;
  let vorbelegterTarifbereich = tarifbereiche[0];

  if (!alleTarifbereicheGleich) {
    vorbelegterTarifbereich = tarifbereiche.find(
      tarifbereich => tarifbereich === Tarifbereich.A || tarifbereich === Tarifbereich.FI,
    );
  }

  yield call(
    GlobalPut.getInstance().put,
    new GlobalActions().assekuranztarifMixed(assekuranztarifMixed),
  );
  yield call(
    GlobalPut.getInstance().put,
    new GlobalActions().tarifbereichChanged(vorbelegterTarifbereich),
  );

  //update isAssekuranztarif
  yield call(
    GlobalPut.getInstance().put,
    new GlobalActions().updateAssekuranztarifData(vorbelegterTarifbereich !== Tarifbereich.E),
  );
  yield call(
    GlobalPut.getInstance().put,
    new ToolbarActions().updateCurrentVNRole(convertTarifbereichToRole(vorbelegterTarifbereich)),
  );
  yield call(
    GlobalPut.getInstance().put,
    new ToolbarActions().updateVorbelegteVNRole(convertTarifbereichToRole(vorbelegterTarifbereich)),
  );
  yield call(
    GlobalPut.getInstance().put,
    new ToolbarActions().vnRoleSelectionChanged(convertTarifbereichToRole(vorbelegterTarifbereich)),
  );

  yield call(GlobalPut.getInstance().put, new GlobalActions().assekuranztarifVorbelegt());
}
